import React, { useState } from "react";
import { Heading } from "../../../design/heading";
import {
  DescriptionList,
  DescriptionTerm,
  DescriptionDetails,
} from "../../../design/description-list";
import { Button } from "../../../design/button";
import { Participant } from "../../../models/Participant";
import { monthlyExpenseFields } from "../../../constants/monthlyExpenseFields";
import EmptyStateView from "../../../components/EmptyStateView";
import EducationForm from "../../../components/Forms/EducationForm";

const ParticipantEducation: React.FC<{ participant: Participant }> = ({
  participant,
}) => {
  const [showForm, setShowForm] = useState(false);
  const education = participant.education;

  const getLabel = (key: string): string => {
    return monthlyExpenseFields.find((f) => f.name === key)?.label || key;
  };

  const hasExpenses =
    education &&
    Object.values(education).some((val) => {
      if (typeof val === "object" && val !== null) {
        return Object.values(val).some(
          (subVal) => subVal && subVal !== "0" && subVal !== 0,
        );
      }
      return val && val !== "0" && val !== 0;
    });

  const shouldShowEmptyStateView = !hasExpenses;

  return (
    <div className="mt-8">
      <div className="flex items-center justify-between">
        <Heading>Education</Heading>
        <Button
          plain
          type="button"
          onClick={() => setShowForm((prev) => !prev)}
        >
          {showForm ? "Hide" : "Edit Education"}
        </Button>
      </div>

      {shouldShowEmptyStateView && !showForm && (
        <div className="mt-4">
          <EmptyStateView
            title="No Expense Details"
            message="No expense details found for this participant."
          />
        </div>
      )}

      {!showForm && hasExpenses && (
        <div className="mt-4">
          <DescriptionList>
            {Object.entries(education).map(([key, val]) => {
              if (!val) return null;
              if (Array.isArray(val)) {
                return val.map((other, idx) => (
                  <React.Fragment key={`${key}-${idx}`}>
                    <DescriptionTerm>{other.label}</DescriptionTerm>
                    <DescriptionDetails>{other.amount}</DescriptionDetails>
                  </React.Fragment>
                ));
              }
              return (
                <React.Fragment key={key}>
                  <DescriptionTerm>{getLabel(key)}</DescriptionTerm>
                  <DescriptionDetails>{val}</DescriptionDetails>
                </React.Fragment>
              );
            })}
          </DescriptionList>
        </div>
      )}

      {showForm && (
        <div className="mt-6">
          <EducationForm
            participantId={participant._id}
            value={education}
            onFormSubmitted={() => setShowForm(false)}
          />
        </div>
      )}
    </div>
  );
};

export default ParticipantEducation;
